import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { ClockIcon } from "../../../../assets/icons";
import { ClientProjectAssignmentSummaryDTO } from "../../../../models/client-project-assignment-summary/client-project-assignment-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";

const MyTeamProjectAssignmentsInProgressLink = ({
  customSummary,
  loading,
}: {
  customSummary: ClientProjectAssignmentSummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.my_team_project_assignments.in_progress";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      // title={`${t(`${tRP}.title`)}`}
      mainInfo={customSummary?.projectsInProgress?.toString() ?? "0"}
      description={`${t(`${tRP}.title`)}`}
      Icon={ClockIcon}
      IconStyle={{
        color: theme.palette.error.main,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
    />
  );
};
export default MyTeamProjectAssignmentsInProgressLink;
